import { companyId, userId } from 'helpers/userSessionSettings';
import supportsLocalStorage from 'helpers/supportsLocalStorage';
import { COMPANY_SCOPED_KEY_PATTERN } from 'helpers/buildStorageKeyFor';

const LAST_SESSION_ID_KEY = '__cwo_last_session_id__';

const shouldPurgeKey = (key) => (
  key !== LAST_SESSION_ID_KEY
  && !COMPANY_SCOPED_KEY_PATTERN.test(key)
);

const purgeUnscopedLocalStorageKeys = () => {
  const allKeys = Array.from(
    { length: localStorage.length },
    (_, i) => localStorage.key(i),
  ).filter((key) => typeof key === 'string');

  for (const key of allKeys.filter(shouldPurgeKey)) {
    localStorage.removeItem(key);
  }
};

const cleanStaleLocalStorageOnSessionSwitch = () => {
  if (!supportsLocalStorage()) return;
  if (companyId == null || userId == null) return;

  try {
    const currentSessionId = `c-${companyId}--u-${userId}`;
    const lastSessionId = localStorage.getItem(LAST_SESSION_ID_KEY);
    if (lastSessionId === currentSessionId) return;

    purgeUnscopedLocalStorageKeys();
    localStorage.setItem(LAST_SESSION_ID_KEY, currentSessionId);
  } catch {
    /* empty */
  }
};

cleanStaleLocalStorageOnSessionSwitch();
